import apiUser from '../api/userAPI';

const agentLogin = async (params) => {
    const property = await apiUser.agentLogin(params);
    return property;
};

const getUserSignOnKey = async (key) => {
    const property = await apiUser.getUserSignOnKey(key);
    return property;
};

const peekPurchaseSerialCode = async (id) => {
    const serialCode = await apiUser.peekPurchaseSerialCode(id);
    return serialCode;
};

const peekRentSerialCode = async (id) => {
    const serialCode = await apiUser.peekRentSerialCode(id);
    return serialCode;
};

const peekRentReceiptSerialCode = async (id) => {
    const serialCode = await apiUser.peekRentReceiptSerialCode(id);
    return serialCode;
};

const peekPurchaseCumReceiptSerialCode = async (id) => {
    const serialCode = await apiUser.peekPurchaseCumReceiptSerialCode(id);
    return serialCode;
};

const peekDeveloperSaleSerialCode = async (id) => {
    const serialCode = await apiUser.peekDeveloperSaleSerialCode(id);
    return serialCode;
};

const peekEmploymentFormSerialCode = async (id) => {
    const serialCode = await apiUser.peekEmploymentFormSerialCode(id);
    return serialCode;
};

const getBranchDetails = async (id) => {
    const serialCode = await apiUser.getBranchDetails(id);
    return serialCode;
};

const keyValue = async (search, userStatus) => {
    // console.log(search)
    const serialCode = await apiUser.keyValue(search, userStatus);
    return serialCode;
};

const createNextsixAgentLink = async (agentId) => {
    const url = await apiUser.createNextsixAgentLink(agentId);
    return url;
};

const resetPassword = async (agentId, loginName, userPassword) => {
    const url = await apiUser.resetPassword(agentId, loginName, userPassword);
    return url;
};


const invalid = (err) => {
    return {
        ok: false,
        err: err,
    };
};

const validateUserPassword = (userAccessData) => {
    if (!userAccessData.userPassword) return invalid("Password is required");
    if (userAccessData.userPassword.length < 6) return invalid("Password minimum length is 6");
    if (userAccessData.userPassword.length > 15) return invalid("Password maximum length is 15");
    if (userAccessData.userPassword !== userAccessData.reUserPassword) return invalid("Passwords do not match");

    return {
        ok: true,
    };
}

const validateUserLogin = (userAccessData) => {
    if (!userAccessData.username) return invalid("Your username must be required.");
    if (!userAccessData.password) return invalid("Your password must be required.");

    return {
        ok: true,
    };
}

const uploadProfileImage = async (agentId, codebase64) => {
    const result = await apiUser.uploadProfileImage(agentId, codebase64)
    return result;
}

const getAgentDetails = async (agentId) => {
    const result = await apiUser.getAgentDetails(agentId)
    return result;
}



export default {
    getUserSignOnKey: getUserSignOnKey,
    peekPurchaseSerialCode: peekPurchaseSerialCode,
    peekRentSerialCode: peekRentSerialCode,
    peekRentReceiptSerialCode: peekRentReceiptSerialCode,
    peekPurchaseCumReceiptSerialCode: peekPurchaseCumReceiptSerialCode,
    peekDeveloperSaleSerialCode: peekDeveloperSaleSerialCode,
    peekEmploymentFormSerialCode: peekEmploymentFormSerialCode,
    getBranchDetails: getBranchDetails,
    keyValue: keyValue,
    createNextsixAgentLink: createNextsixAgentLink,
    resetPassword: resetPassword,
    validateUserPassword: validateUserPassword,
    validateUserLogin: validateUserLogin,
    agentLogin: agentLogin,
    uploadProfileImage: uploadProfileImage,
    getAgentDetails: getAgentDetails
};